var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImagePlaceholder = function SvgImagePlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 87,
    viewBox: "0 0 80 87"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M28 0h52v72H28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 .164h31v24.457H0"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "200%",
    height: "200%",
    x: "-50%",
    y: "-50%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0073AE",
    d: "m28.133 0 47.866 20.318-28.133 66.276L0 66.276zm2.119 5.245 40.502 17.192L49.85 71.684 9.348 54.492z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "#000",
    filter: "url(#a)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0073AE",
    d: "M28 0h52v72H28zm4 4h44v54H32z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 19 48)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0073AE",
    d: "m4.842 10.714 8.314-8.127a1.49 1.49 0 0 0 0-2.143 1.576 1.576 0 0 0-2.192 0L.004 11.157q-.108.106-.193.231c-.026.039-.044.08-.066.12-.026.047-.055.091-.076.141-.022.051-.034.105-.05.158-.012.042-.029.082-.038.125a1.5 1.5 0 0 0 0 .593c.009.046.026.088.04.132.015.05.027.102.048.15.022.053.052.101.08.15.021.038.037.076.062.111q.086.126.194.233l10.96 10.712a1.576 1.576 0 0 0 2.191 0 1.49 1.49 0 0 0 0-2.142l-8.314-8.127H29v-3.03z",
    mask: "url(#d)"
  })))));
};
export default SvgImagePlaceholder;